import { isGundamProduct } from '../../../own-days/views/desktop/Gundam/gundamHelper';

/**
 * @param {Object} productData
 * @returns {boolean} - Returns true if the text should be hidden
 */
export const isHideTextGundamAccessories = productData => {
  if (!productData) return false;

  return (
    productData?.type?.toLowerCase() === 'accessories' ||
    !productData?.specifications?.some(
      spec => spec.name === 'general' && spec.items?.some(item => item.name === 'Frame Dimensions')
    )
  );
};

/**
 * @param {Object} productData
 * @returns {boolean} - Returns true if the product is an accessory
 */
export const isAccessories = productData => {
  if (!productData) return false;

  // Check if the product is a accessory
  const isAccessory =
    productData?.type?.toLowerCase() === 'accessories' &&
    productData?.classification?.toLowerCase() === 'accessories_revenue';

  // Check if the product is a Gundam accessory
  const isGundamAccessory =
    isGundamProduct(productData?.id) && isHideTextGundamAccessories(productData);

  return isAccessory || isGundamAccessory;
};
